var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVideoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 .993C0 .445.445 0 .993 0h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H.993A.994.994 0 0 1 0 17.007zM2 2v14h14V2zm5.622 3.415 4.879 3.252a.4.4 0 0 1 0 .666l-4.88 3.252A.4.4 0 0 1 7 12.253V5.747a.4.4 0 0 1 .622-.332"
})));
export { SvgVideoIcon as ReactComponent };
export default __webpack_public_path__ + "9a2acf0c74304eaa68f188346b93955e.svg";